import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { SvelteMap } from "svelte/reactivity";
import DisplayFields from "./DisplayFields.svelte";
import { draftOfSettings, settingsOfDraft } from "../utils/config-pages.js";
import { MvgStationRepository } from "../adapters/mvg/mvg-station-repository.js";
import { CompositeDepartureRepository } from "../adapters/composite-departure-repository.js";
import { createStopConfiguration } from "../domain/models/stop-configuration.js";
import { destinationPattern, linePattern, observedLines } from "../application/services/observed-lines.js";

const chevron = ($$anchor, open = $.noop) => {
	var svg = root();
	let classes;

	$.template_effect(() => classes = $.set_class(svg, 0, 'chevron', null, classes, { 'chevron-open': open() }));
	$.append($$anchor, svg);
};

const plus = ($$anchor) => {
	var svg_1 = root_1();

	$.append($$anchor, svg_1);
};

var root = $.from_svg(`<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd"></path></svg>`);
var root_1 = $.from_svg(`<svg class="chevron" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"></path></svg>`);
var root_2 = $.from_html(`<div class="row sub svelte-1gvvmj6"><div class="row-open is-static svelte-1gvvmj6"><span class="row-text svelte-1gvvmj6"><span class="name svelte-1gvvmj6"> </span> <span class="meta svelte-1gvvmj6"> </span></span></div></div>`);

var root_3 = $.from_html(
	`<div class="page-row svelte-1gvvmj6"><div class="row-open is-static svelte-1gvvmj6"><span class="row-text svelte-1gvvmj6"><span class="name svelte-1gvvmj6"> </span> <span class="meta svelte-1gvvmj6"> </span></span></div></div> <div class="children svelte-1gvvmj6"><p class="note svelte-1gvvmj6">Stops outside any route, the way the server version wants them.
              The board shows them as “/”. Converting rewrites them as
              [[routes]], and you see the result before anything changes.</p> <!> <div class="actions svelte-1gvvmj6"><button class="button button-secondary" data-role="convert">Convert to routes…</button></div></div>`,
	1
);

var root_4 = $.from_html(`<p class="problem svelte-1gvvmj6" role="alert"> </p>`);
var root_5 = $.from_html(`<div class="form svelte-1gvvmj6"><label class="field svelte-1gvvmj6"><span>Title</span> <input aria-label="Route title" class="svelte-1gvvmj6"/></label> <label class="field svelte-1gvvmj6"><span>Path</span> <input aria-label="Route path" class="svelte-1gvvmj6"/></label> <!> <!> <div class="actions svelte-1gvvmj6"><button class="button button-secondary">Cancel</button> <button class="button button-primary">Apply</button></div></div>`);
var root_6 = $.from_html(`<p class="note svelte-1gvvmj6">No match yet - this direction filters nothing.</p>`);
var root_7 = $.from_html(`<div class="match svelte-1gvvmj6" data-role="match"><input class="svelte-1gvvmj6"/> <button class="icon-button svelte-1gvvmj6">×</button></div>`);
var root_8 = $.from_html(`<p class="note svelte-1gvvmj6">Loading the stop's lines…</p>`);
var root_9 = $.from_html(`<p class="note svelte-1gvvmj6">The departures named no line.</p>`);
var root_10 = $.from_html(`<label class="field svelte-1gvvmj6"><span>Filter the lines</span> <input placeholder="18, S3, Stachus…" class="svelte-1gvvmj6"/></label>`);
var root_11 = $.from_html(`<button> </button>`);
var root_12 = $.from_html(`<div class="line-row svelte-1gvvmj6"><button> </button> <button class="chip svelte-1gvvmj6"> </button> <!></div>`);
var root_13 = $.from_html(`<!> <!>`, 1);
var root_14 = $.from_html(`<button class="button button-secondary">Load the stop's lines</button>`);
var root_15 = $.from_html(`<div class="children svelte-1gvvmj6"><label class="field svelte-1gvvmj6"><span>Name</span> <input placeholder="->City" class="svelte-1gvvmj6"/></label> <div class="matches svelte-1gvvmj6" data-role="matches"><!> <!></div> <label class="field svelte-1gvvmj6"><span>Add a match</span> <input placeholder="18 Stachus, 18, or Stachus" class="svelte-1gvvmj6"/></label> <!> <button class="button button-secondary delete svelte-1gvvmj6">⨯ Direction</button></div>`);
var root_16 = $.from_html(`<div class="row sub2 svelte-1gvvmj6"><button class="row-open svelte-1gvvmj6" data-role="direction"><span class="row-text svelte-1gvvmj6"><span class="name svelte-1gvvmj6"> </span> <span class="meta svelte-1gvvmj6"> </span></span> <!></button></div> <!>`, 1);
var root_17 = $.from_html(`<div class="actions svelte-1gvvmj6"><button class="button button-secondary">Keep</button> <button class="button button-secondary delete svelte-1gvvmj6"> </button></div>`);
var root_18 = $.from_html(`<div class="actions svelte-1gvvmj6"><button class="button button-secondary delete svelte-1gvvmj6">⨯ Stop</button></div>`);
var root_19 = $.from_html(`<div class="children svelte-1gvvmj6"><label class="field svelte-1gvvmj6"><span>Name</span> <input class="svelte-1gvvmj6"/></label> <label class="field svelte-1gvvmj6"><span>Unmatched show under</span> <input placeholder="Other" class="svelte-1gvvmj6"/></label> <label class="check svelte-1gvvmj6"><input type="checkbox" class="svelte-1gvvmj6"/> <span>Show what matches no direction</span></label> <div class="grid svelte-1gvvmj6"><label class="field svelte-1gvvmj6"><span>Rows / stop</span> <input type="number" min="0" class="svelte-1gvvmj6"/></label> <label class="field svelte-1gvvmj6"><span>Rows / line</span> <input type="number" min="0" class="svelte-1gvvmj6"/></label> <label class="field svelte-1gvvmj6"><span>Hours ahead</span> <input type="number" min="0" placeholder="all" class="svelte-1gvvmj6"/></label></div> <!> <button class="row add svelte-1gvvmj6" data-role="add-direction"><!> <span class="name svelte-1gvvmj6">Direction</span></button> <!></div>`);
var root_20 = $.from_html(`<div class="row sub svelte-1gvvmj6"><button class="row-open svelte-1gvvmj6" data-role="stop"><span class="row-text svelte-1gvvmj6"><span class="name svelte-1gvvmj6"> </span> <span class="meta svelte-1gvvmj6"> </span></span> <!></button></div> <!>`, 1);
var root_21 = $.from_html(`<button class="row sub svelte-1gvvmj6"><span class="name svelte-1gvvmj6"> </span> <span class="meta svelte-1gvvmj6"> </span> <!></button>`);
var root_22 = $.from_html(`<div class="form svelte-1gvvmj6"><label class="field svelte-1gvvmj6"><span>Find a stop</span> <input placeholder="e.g. Giesing" aria-label="Search a stop to add" class="svelte-1gvvmj6"/></label> <div class="actions svelte-1gvvmj6"><button class="button button-secondary">Cancel</button> <button class="button button-primary"> </button></div> <!> <!></div>`);
var root_23 = $.from_html(`<button class="row add svelte-1gvvmj6" data-role="add-stop"><!> <span class="name svelte-1gvvmj6">Stop</span></button>`);
var root_24 = $.from_html(`<button class="button button-secondary">Keep</button> <button class="button button-secondary delete svelte-1gvvmj6"> </button>`, 1);
var root_25 = $.from_html(`<button class="button button-secondary delete svelte-1gvvmj6">⨯ Route</button>`);
var root_26 = $.from_html(`<div class="children svelte-1gvvmj6"><!> <!> <!> <div class="actions svelte-1gvvmj6"><button class="button button-secondary" data-role="page-settings">⚙ Settings</button> <!></div></div>`);
var root_27 = $.from_html(`<div><span class="grip svelte-1gvvmj6" role="button" tabindex="0">⠿</span> <button class="row-open svelte-1gvvmj6" data-role="page"><span class="row-text svelte-1gvvmj6"><span class="name svelte-1gvvmj6"> </span> <span class="meta svelte-1gvvmj6"> </span></span> <!></button></div> <!>`, 1);
var root_28 = $.from_html(`<li><!></li>`);

var root_29 = $.from_html(`<p class="note svelte-1gvvmj6">This file has no stops and no routes yet. Add a route, or paste a config
      in the TOML tab.</p>`);

var root_30 = $.from_html(`<div class="form svelte-1gvvmj6"><label class="field svelte-1gvvmj6"><span>Path</span> <input placeholder="/work" aria-label="New route path" class="svelte-1gvvmj6"/></label> <label class="field svelte-1gvvmj6"><span>Title</span> <input placeholder="the path, unless you name it" aria-label="New route title" class="svelte-1gvvmj6"/></label> <!> <div class="actions svelte-1gvvmj6"><button class="button button-secondary">Cancel</button> <button class="button button-primary">Create</button></div></div>`);
var root_31 = $.from_html(`<div class="actions svelte-1gvvmj6"><button class="button button-secondary" data-role="add-page">+ Route</button> <button class="button button-secondary">Wizard…</button></div>`);
var root_32 = $.from_html(`<div class="form svelte-1gvvmj6"><!> <div class="actions svelte-1gvvmj6"><button class="button button-secondary">Cancel</button> <button class="button button-primary">Apply</button></div></div>`);
var root_33 = $.from_html(`<button class="row disclosure svelte-1gvvmj6" data-role="defaults"><span class="row-text svelte-1gvvmj6"><span class="name svelte-1gvvmj6">Defaults for every page</span> <span class="meta svelte-1gvvmj6"> </span></span> <!></button>`);
var root_34 = $.from_html(`<div class="cfg svelte-1gvvmj6"><ul class="rows svelte-1gvvmj6"></ul> <!> <!> <!></div>`);

const $$css = {
	hash: 'svelte-1gvvmj6',
	code: '\n  /* The dialog owns the type and the buttons; the configurator only adds the\n     layout of one line per row. Font sizes follow the other screens: 1rem for\n     names, 0.875rem for the meta line. */.cfg.svelte-1gvvmj6 {display:flex;flex-direction:column;gap:0.5rem;flex:1 1 auto;min-height:0;min-width:0;\n    /* Material\'s advice for wide screens: keep the line length readable\n       instead of stretching a list across a 27 inch display. */width:100%;max-width:44rem;margin:0 auto;overflow-y:auto;overflow-x:hidden;font-size:0.9375rem;color:#111827;}.rows.svelte-1gvvmj6 {list-style:none;margin:0;padding:0;display:flex;flex-direction:column;border-top:1px solid #e5e7eb;}.row.svelte-1gvvmj6 {display:flex;align-items:center;gap:0.5rem;width:100%;min-height:3rem;padding:0;border:none;border-bottom:1px solid #e5e7eb;background:transparent;color:#111827;font:inherit;text-align:left;cursor:pointer;}.row.svelte-1gvvmj6:last-child {border-bottom:none;}\n\n  /* A row is one tappable line: the label with what it holds underneath, and\n     the disclosure chevron at the trailing edge (Material\'s "label text with\n     supporting text" list item). */.row-open.svelte-1gvvmj6 {display:flex;align-items:center;gap:0.5rem;flex:1 1 auto;min-width:0;min-height:3.5rem;padding:0.3rem 0;border:none;background:transparent;color:inherit;font:inherit;text-align:left;cursor:pointer;touch-action:manipulation;}.row-open.svelte-1gvvmj6:active {background:#e5e7eb;}\n\n  /* A row the file decides, not the finger: no tap, no hover. */.row-open.is-static.svelte-1gvvmj6 {cursor:default;}.row-open.is-static.svelte-1gvvmj6:active {background:transparent;}[data-theme="dark"] .row-open.svelte-1gvvmj6:active {background:#1f2937;}.row-text.svelte-1gvvmj6 {display:flex;flex-direction:column;gap:0.1rem;flex:1 1 auto;min-width:0;}.page-row.svelte-1gvvmj6 {display:flex;align-items:center;gap:0.25rem;}.page-row.dragging.svelte-1gvvmj6 {opacity:0.5;}.page-row.drop-target.svelte-1gvvmj6 {outline:2px solid #087bc4;outline-offset:-2px;}\n\n  /* The grip is the only part that starts a drag, so a tap still opens the page.\n     It is as wide as a thumb, like the chevron. */.grip.svelte-1gvvmj6 {display:flex;align-items:center;justify-content:center;flex:0 0 2.75rem;min-height:2.75rem;color:#6b7280;font-size:1.1rem;line-height:1;cursor:grab;touch-action:none;user-select:none;}.grip.svelte-1gvvmj6:active {cursor:grabbing;}[data-theme="dark"] .grip.svelte-1gvvmj6 {color:#9ca3af;}.row.svelte-1gvvmj6:active {background:#e5e7eb;}.row.svelte-1gvvmj6 .name:where(.svelte-1gvvmj6) {flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500;}.row.svelte-1gvvmj6 .meta:where(.svelte-1gvvmj6) {color:#6b7280;font-size:0.8125rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}\n\n  /* The second line is supporting text, not a second column: it never wraps\n     and never pushes the label aside. */.row-text.svelte-1gvvmj6 .name:where(.svelte-1gvvmj6),\n  .row-text.svelte-1gvvmj6 .meta:where(.svelte-1gvvmj6) {display:block;flex:0 1 auto;}\n\n  /* The row\'s icon. It is drawn by a snippet, so it has no scope class: only a\n     rule anchored at .cfg reaches it. The closed chevron turns a quarter turn\n     to say "open". */.cfg.svelte-1gvvmj6 .chevron {flex:0 0 auto;color:#087bc4;transition:transform 120ms ease;}.cfg.svelte-1gvvmj6 .chevron-open {transform:rotate(90deg);}.row.sub.svelte-1gvvmj6 .row-text:where(.svelte-1gvvmj6) .name:where(.svelte-1gvvmj6) {font-size:0.9375rem;}.row.sub2.svelte-1gvvmj6 .row-text:where(.svelte-1gvvmj6) .name:where(.svelte-1gvvmj6) {font-size:0.875rem;}.row.add.svelte-1gvvmj6 .name:where(.svelte-1gvvmj6) {color:#087bc4;}.children.svelte-1gvvmj6 {display:flex;flex-direction:column;gap:0.5rem;padding:0.5rem 0;}.field.svelte-1gvvmj6 {display:flex;flex-direction:column;gap:0.15rem;min-width:0;font-size:0.875rem;color:#4b5563;}.field.svelte-1gvvmj6 input:where(.svelte-1gvvmj6),\n  .match.svelte-1gvvmj6 input:where(.svelte-1gvvmj6) {width:100%;min-width:0;min-height:2.75rem;padding:0.4rem 0.5rem;border:1px solid #d1d5db;border-radius:0.375rem;background:#ffffff;color:#111827;font:inherit;font-size:1rem;}.check.svelte-1gvvmj6 {display:flex;align-items:center;gap:0.5rem;min-height:2.75rem;font-size:1rem;color:#111827;}.check.svelte-1gvvmj6 input:where(.svelte-1gvvmj6) {flex:0 0 auto;width:1.25rem;height:1.25rem;accent-color:#087bc4;}.grid.svelte-1gvvmj6 {display:grid;grid-template-columns:repeat(auto-fit, minmax(5rem, 1fr));gap:0.5rem;}.form.svelte-1gvvmj6 {display:flex;flex-direction:column;gap:0.5rem;padding:0.5rem;border:1px solid #e5e7eb;border-radius:0.5rem;background:#f9fafb;}.note.svelte-1gvvmj6,\n  .problem.svelte-1gvvmj6 {margin:0;font-size:0.875rem;}.note.svelte-1gvvmj6 {color:#4b5563;}.problem.svelte-1gvvmj6 {color:#b91c1c;}.actions.svelte-1gvvmj6 {display:flex;flex-wrap:wrap;gap:0.5rem;}.actions.svelte-1gvvmj6 .button {min-height:2.75rem;}.delete.svelte-1gvvmj6 {border:1px solid #b91c1c;background:transparent;color:#b91c1c;font-weight:500;}[data-theme="dark"] .delete.svelte-1gvvmj6 {border-color:#fca5a5;color:#fca5a5;}.matches.svelte-1gvvmj6 {display:flex;flex-direction:column;gap:0.25rem;}.icon-button.svelte-1gvvmj6 {flex:0 0 auto;min-width:2.75rem;min-height:2.75rem;border:1px solid #d1d5db;border-radius:0.375rem;background:#ffffff;color:#111827;font:inherit;font-size:1rem;cursor:pointer;}.line-row.svelte-1gvvmj6 {display:flex;flex-wrap:wrap;align-items:center;gap:0.35rem;}.chip.svelte-1gvvmj6 {min-height:2.5rem;max-width:100%;padding:0.25rem 0.75rem;border:1px solid #d1d5db;border-radius:0.375rem;background:#ffffff;color:#111827;font:inherit;font-size:0.875rem;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}.chip.line.svelte-1gvvmj6 {min-width:2.5rem;font-weight:600;}\n\n  /* A match the direction already holds: filled, and tapping it adds nothing. */.chip.is-on.svelte-1gvvmj6 {background:#087bc4;border-color:#087bc4;color:#ffffff;}.match.svelte-1gvvmj6 {display:flex;align-items:center;gap:0.35rem;}.row.svelte-1gvvmj6:focus-visible,\n  .chip.svelte-1gvvmj6:focus-visible,\n  .icon-button.svelte-1gvvmj6:focus-visible {outline:2px solid #087bc4;outline-offset:2px;}\n\n  /* Dark theme, the same shapes and the dialog\'s colours. */[data-theme="dark"] .cfg.svelte-1gvvmj6,\n  [data-theme="dark"] .row.svelte-1gvvmj6,\n  [data-theme="dark"] .check.svelte-1gvvmj6 {color:#f9fafb;}[data-theme="dark"] .rows.svelte-1gvvmj6,\n  [data-theme="dark"] .form.svelte-1gvvmj6 {background:#111827;border-color:#374151;}[data-theme="dark"] .row.svelte-1gvvmj6 {border-bottom-color:#374151;}[data-theme="dark"] .row.svelte-1gvvmj6:active {background:#374151;}[data-theme="dark"] .row.svelte-1gvvmj6 .meta:where(.svelte-1gvvmj6),\n  [data-theme="dark"] .note.svelte-1gvvmj6,\n  [data-theme="dark"] .field.svelte-1gvvmj6 {color:#d1d5db;}[data-theme="dark"] .cfg.svelte-1gvvmj6 .chevron,\n  [data-theme="dark"] .row.add.svelte-1gvvmj6 .name:where(.svelte-1gvvmj6) {color:#93c5fd;}[data-theme="dark"] .row.svelte-1gvvmj6 .meta:where(.svelte-1gvvmj6) {color:#9ca3af;}[data-theme="dark"] .field.svelte-1gvvmj6 input:where(.svelte-1gvvmj6),\n  [data-theme="dark"] .match.svelte-1gvvmj6 input:where(.svelte-1gvvmj6),\n  [data-theme="dark"] .chip.svelte-1gvvmj6,\n  [data-theme="dark"] .icon-button.svelte-1gvvmj6 {background:#1f2937;border-color:#4b5563;color:#f9fafb;}[data-theme="dark"] .chip.is-on.svelte-1gvvmj6 {background:#087bc4;border-color:#087bc4;color:#ffffff;}[data-theme="dark"] .problem.svelte-1gvvmj6 {color:#fca5a5;}'
};

export default function ConfigPages($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	/* global HTMLInputElement, PointerEvent */
	/** The file's own display settings, which every page inherits. */
	/** Turns a server-format file's stops into routes, as a reviewable edit. */
	/**
	 * One context at a time: a page, one of its stops, one of that stop's
	 * headings, or one form. Opening one closes the others, so the dialog never
	 * grows into a wall of fields on a phone.
	 */
	let openPage = $.state(null);

	let openStop = $.state(null);
	let openHeading = $.state(null);
	let openForm = $.state(null);

	/** What is being deleted: "page:0", "stop:0:1". */
	let confirming = $.state(null);

	/** A page drag in flight: where it started, and where it would land. */
	let dragFrom = $.state(null);

	let dragOver = $.state(null);

	function pageRows() {
		return [...document.querySelectorAll('[data-role="page"]')];
	}

	/**
	 * Dragging a page by its grip. Nothing moves until the pointer is released, and
	 * Escape or a cancelled pointer leaves the order exactly as it was.
	 */
	function startDrag(event, index) {
		event.preventDefault();
		$.set(dragFrom, index, true);
		$.set(dragOver, index, true);

		const move = (moveEvent) => {
			const row = pageRows().find((each) => {
				const rect = each.getBoundingClientRect();

				return moveEvent.clientY >= rect.top && moveEvent.clientY <= rect.bottom;
			});

			const at = row?.dataset.index === undefined ? NaN : Number(row.dataset.index);

			if (Number.isInteger(at)) {
				$.set(dragOver, at, true);
			}
		};

		const finish = (commit) => {
			window.removeEventListener("pointermove", move);
			window.removeEventListener("pointerup", drop);
			window.removeEventListener("pointercancel", abort);
			window.removeEventListener("keydown", escape);

			const from = $.get(dragFrom);
			const to = $.get(dragOver);

			$.set(dragFrom, null);
			$.set(dragOver, null);

			if (commit && from !== null && to !== null && from !== to) {
				$$props.onReorder(from, to);
			}
		};

		const drop = () => finish(true);
		const abort = () => finish(false);

		const escape = (keyEvent) => {
			if (keyEvent.key === "Escape") {
				finish(false);
			}
		};

		window.addEventListener("pointermove", move);
		window.addEventListener("pointerup", drop);
		window.addEventListener("pointercancel", abort);
		window.addEventListener("keydown", escape);
	}

	/** The line whose destinations are shown, and the filter over the lines. */
	let openLine = $.state(null);

	let lineFilter = $.state("");
	let pageDraft = $.state(null);
	let defaultsDraft = $.state(null);
	let newPageDraft = $.state(null);
	let stopQuery = $.state("");
	let stopMatches = $.state($.proxy([]));
	let isSearchingStops = $.state(false);
	let stopSearchProblem = $.state("");

	/** The lines each stop's departures showed, by station id. */
	const linesByStop = new SvelteMap();

	const linesLoading = new SvelteMap();
	const linesProblem = new SvelteMap();
	const searchableStations = new MvgStationRepository();

	/** What an unset key means: the domain's own defaults, shown in the fields. */
	const stopDefaults = createStopConfiguration({ stationId: "", stationName: "" });

	// A page or a stop that just went away must not leave its context open.
	$.user_effect(() => {
		if ($.get(openPage) !== null && $.get(openPage) >= $$props.pages.length) {
			$.set(openPage, null);
			$.set(openStop, null);
			$.set(openHeading, null);
		}

		const stops = $.get(openPage) === null ? undefined : $$props.pages[$.get(openPage)]?.stops;

		if (stops && $.get(openStop) !== null && $.get(openStop) >= stops.length) {
			$.set(openStop, null);
			$.set(openHeading, null);
		}
	});

	function togglePage(index) {
		const opening = $.get(openPage) !== index;

		$.set(openPage, opening ? index : null, true);
		$.set(openStop, null);
		$.set(openHeading, null);
		$.set(confirming, null);

		if (!opening) {
			$.set(openForm, null);
		}
	}

	function toggleStop(index, stop) {
		const opening = $.get(openStop) !== index;

		$.set(openStop, opening ? index : null, true);
		$.set(openHeading, null);
		$.set(openForm, null);
		$.set(openLine, null);
		$.set(lineFilter, "");
		$.set(confirming, null);

		if (opening) {
			void loadLines(stop);
		}
	}

	function toggleHeading(index) {
		$.set(openHeading, $.get(openHeading) === index ? null : index, true);
		$.set(openLine, null);
		$.set(lineFilter, "");
	}

	function toggleForm(form) {
		const opening = $.get(openForm) !== form;

		$.set(openForm, opening ? form : null, true);
		$.set(confirming, null);

		if (!opening) {
			$.set(pageDraft, null);
			$.set(defaultsDraft, null);
			$.set(newPageDraft, null);
		}
	}

	/* ---- the page's own form ---- */
	function openPageForm(page) {
		$.set(
			pageDraft,
			{
				path: page.path,
				title: page.title,
				settings: draftOfSettings(page.display)
			},
			true
		);

		toggleForm("page");
	}

	/** Why the draft cannot be applied, or "" while it can. */
	const pathProblem = $.derived(() => {
		const draft = $.get(pageDraft);

		if (draft === null || $.get(openPage) === null) {
			return "";
		}

		const path = draft.path.trim();

		if (!path.startsWith("/")) {
			return "A path starts with a slash, like /work.";
		}

		return $$props.pages.some((page, at) => at !== $.get(openPage) && page.path === path) ? "Another page already uses this path." : "";
	});

	/**
	 * Only the page's own text and settings: the stops are edited where they are
	 * shown, so this form leaves their headings exactly as they are.
	 */
	function applyPageDraft(index) {
		if ($.get(pageDraft) === null || $.get(pathProblem) !== "") {
			return;
		}

		const edit = {
			path: $.get(pageDraft).path.trim(),
			title: $.get(pageDraft).title,
			stops: $$props.pages[index].stops.map((stop) => ({ label: stop.label, showUngrouped: stop.showUngrouped }))
		};

		const settings = settingsOfDraft($.get(pageDraft).settings);

		$.set(openForm, null);
		$.set(pageDraft, null);
		$$props.onApplyPage(index, edit);
		$$props.onApplyPageDisplay(index, settings);
	}

	function applyDefaults() {
		if ($.get(defaultsDraft) === null) {
			return;
		}

		const values = settingsOfDraft($.get(defaultsDraft));

		$.set(defaultsDraft, null);
		$.set(openForm, null);
		$$props.onApplyDefaults(values);
	}

	/* ---- a stop ---- */
	function applyStop(pageIndex, stopIndex, stop, change) {
		$$props.onApplyStop(pageIndex, stopIndex, {
			label: stop.label,
			showUngrouped: stop.showUngrouped,
			directions: stop.directions,
			...change
		});
	}

	/** The stop's headings with the one at `headingIndex` replaced. */
	function withHeading(stop, headingIndex, heading) {
		return stop.directions.map((existing, at) => at === headingIndex ? heading : existing);
	}

	function addHeading(pageIndex, stopIndex, stop) {
		$.set(openHeading, stop.directions.length, true);

		// A direction without a name would be dropped on the way into the file, so a
		// new one starts with a name that says what it is until it is renamed.
		applyStop(pageIndex, stopIndex, stop, {
			directions: [
				...stop.directions,
				{ direction: `->${stop.directions.length + 1}`, patterns: [] }
			]
		});
	}

	function removeHeading(pageIndex, stopIndex, stop, headingIndex) {
		$.set(openHeading, null);

		applyStop(pageIndex, stopIndex, stop, {
			directions: stop.directions.filter((_, at) => at !== headingIndex)
		});
	}

	/** A heading keeps its matches when it is renamed. */
	function renameHeading(pageIndex, stopIndex, stop, headingIndex, name) {
		const heading = stop.directions[headingIndex];

		if (name.trim() === "" || name === heading.direction) {
			return;
		}

		applyStop(pageIndex, stopIndex, stop, {
			directions: withHeading(stop, headingIndex, { ...heading, direction: name })
		});
	}

	/**
	 * A direction is a filter, and its matches are plain text: adding one takes
	 * the text as given ("18", "18 Stachus", "Stachus"), editing one rewrites
	 * just that line, and an emptied match is dropped.
	 */
	function showMatches() {
		requestAnimationFrame(() => {
			document.querySelector('[data-role="matches"]')?.scrollIntoView({ block: "nearest" });
		});
	}

	function addMatch(pageIndex, stopIndex, stop, headingIndex, text) {
		const pattern = text.trim();
		const heading = stop.directions[headingIndex];

		if (pattern === "" || heading.patterns.includes(pattern)) {
			return;
		}

		applyStop(pageIndex, stopIndex, stop, {
			directions: withHeading(stop, headingIndex, { ...heading, patterns: [...heading.patterns, pattern] })
		});

		showMatches();
	}

	function setMatch(pageIndex, stopIndex, stop, headingIndex, patternIndex, text) {
		const heading = stop.directions[headingIndex];
		const pattern = text.trim();

		if (pattern === "" || pattern === heading.patterns[patternIndex]) {
			return;
		}

		applyStop(pageIndex, stopIndex, stop, {
			directions: withHeading(stop, headingIndex, {
				...heading,
				patterns: heading.patterns.map((existing, at) => at === patternIndex ? pattern : existing)
			})
		});
	}

	function removeMatch(pageIndex, stopIndex, stop, headingIndex, patternIndex) {
		const heading = stop.directions[headingIndex];

		applyStop(pageIndex, stopIndex, stop, {
			directions: withHeading(stop, headingIndex, {
				...heading,
				patterns: heading.patterns.filter((_, at) => at !== patternIndex)
			})
		});
	}

	function addTypedMatch(pageIndex, stopIndex, stop, headingIndex, input) {
		const text = input.value;

		input.value = "";
		addMatch(pageIndex, stopIndex, stop, headingIndex, text);
	}

	/** A count from a form field: `null` empties it, `undefined` is not a number. */
	function countFrom(text) {
		const trimmed = text.trim();

		if (trimmed === "") {
			return null;
		}

		const value = Number(trimmed);

		return Number.isInteger(value) && value >= 0 ? value : undefined;
	}

	function applyCount(pageIndex, stopIndex, stop, field, input) {
		const value = countFrom(input.value);

		if (value === undefined) {
			input.value = String(stop[field] ?? "");

			return;
		}

		if (value === (stop[field] ?? null)) {
			return;
		}

		if (field === "maxDepartures") {
			applyStop(pageIndex, stopIndex, stop, { maxDepartures: value });
		} else if (field === "perLineDepartures") {
			applyStop(pageIndex, stopIndex, stop, { perLineDepartures: value });
		} else {
			applyStop(pageIndex, stopIndex, stop, { hoursInAdvance: value });
		}
	}

	/* ---- the lines a stop's departures showed ---- */
	/**
	 * The API is asked once per stop: its departures say which lines can be
	 * matched, and one pattern for a line is enough when its destinations do not
	 * matter. A stop the API cannot answer for keeps the matches typed by hand.
	 */
	async function loadLines(stop) {
		const id = stop.stationId;

		if (id === "" || linesByStop.has(id) || linesLoading.get(id) === true) {
			return;
		}

		linesLoading.set(id, true);
		linesProblem.delete(id);

		try {
			const departures = await new CompositeDepartureRepository([
				createStopConfiguration({ stationId: id, stationName: stop.name })
			]).getDepartures(id, { limit: 100 });

			linesByStop.set(id, observedLines(departures));
		} catch(error) {
			linesProblem.set(id, error instanceof Error ? error.message : String(error));
		} finally {
			linesLoading.delete(id);
		}
	}

	function linesShownFor(stop) {
		return linesByStop.get(stop.stationId) ?? [];
	}

	/** The stop's lines that the filter box leaves - a big stop needs one. */
	function shownLines(stop) {
		const filter = $.get(lineFilter).trim().toLowerCase();
		const lines = linesShownFor(stop);

		if (filter === "") {
			return lines;
		}

		return lines.filter((line) => line.line.toLowerCase().includes(filter) || line.destinations.some((destination) => destination.toLowerCase().includes(filter)));
	}

	/* ---- adding a stop ---- */
	function openStopSearch() {
		$.set(stopQuery, "");
		$.set(stopMatches, [], true);
		$.set(stopSearchProblem, "");
		toggleForm("add-stop");
	}

	async function searchStops() {
		if ($.get(stopQuery).trim() === "") {
			return;
		}

		$.set(isSearchingStops, true);
		$.set(stopSearchProblem, "");

		try {
			const stations = await searchableStations.searchStations($.get(stopQuery));

			$.set(stopMatches, stations.map((station) => ({ stationId: station.id, stationName: station.name })), true);
			$.set(stopSearchProblem, $.get(stopMatches).length === 0 ? `No stop matches “${$.get(stopQuery).trim()}”.` : "", true);
		} catch(error) {
			$.set(stopSearchProblem, error instanceof Error ? error.message : String(error), true);
		} finally {
			$.set(isSearchingStops, false);
		}
	}

	function addStop(pageIndex, stop) {
		$.set(openForm, null);
		$.set(stopMatches, [], true);
		$.set(stopQuery, "");
		$$props.onAddStop(pageIndex, stop);
	}

	/* ---- a new page ---- */
	const newPageProblem = $.derived(() => {
		const draft = $.get(newPageDraft);

		if (draft === null) {
			return "";
		}

		const path = draft.path.trim();

		if (!path.startsWith("/")) {
			return "A path starts with a slash, like /work.";
		}

		return $$props.pages.some((page) => page.path === path) ? "A page already uses this path." : "";
	});

	const canCreatePage = $.derived(() => $.get(newPageDraft) !== null && $.get(newPageDraft).path.trim() !== "" && $.get(newPageProblem) === "");

	function openNewPage() {
		$.set(newPageDraft, { path: "", title: "" }, true);
		toggleForm("new-page");
	}

	function applyNewPage() {
		if ($.get(newPageDraft) === null || !$.get(canCreatePage)) {
			return;
		}

		const page = {
			path: $.get(newPageDraft).path.trim(),
			title: $.get(newPageDraft).title.trim()
		};

		$.set(newPageDraft, null);
		$.set(openForm, null);
		$$props.onAddPage(page);
	}

	/* ---- what the rows say ---- */
	/** The route's supporting line: how much it holds, and where it lives. */
	function pageSummary(page) {
		const count = page.stops.length;
		const stops = `${count} stop${count === 1 ? "" : "s"}`;

		return page.path === page.title ? stops : `${stops} · ${page.path}`;
	}

	function stopSummary(stop) {
		const count = stop.directions.length;

		return count === 0
			? "no directions"
			: `${count} direction${count === 1 ? "" : "s"}`;
	}

	/** How many settings the defaults actually set, in the file's own words. */
	function settingsSummary(settings) {
		const count = Object.keys(settings).length;

		return count === 0
			? "nothing set here"
			: `${count} setting${count === 1 ? "" : "s"} set here`;
	}

	function headingTitle(heading) {
		return heading.direction.trim() === "" ? "(unnamed)" : heading.direction;
	}

	function headingSummary(heading) {
		const count = heading.patterns.length;

		return `${count} match${count === 1 ? "" : "es"}`;
	}

	var div = root_34();
	var ul = $.child(div);

	$.each(ul, 21, () => $$props.pages, $.index, ($$anchor, page, pageIndex) => {
		var li = root_28();
		var node = $.child(li);

		{
			var consequent = ($$anchor) => {
				var fragment = root_3();
				var div_1 = $.first_child(fragment);
				var div_2 = $.child(div_1);
				var span = $.child(div_2);
				var span_1 = $.child(span);
				var text_1 = $.only_child(span_1, true);
				var span_2 = $.sibling(span_1, 2);
				var text_2 = $.only_child(span_2);

				$.reset(span);
				$.reset(div_2);
				$.reset(div_1);

				var div_3 = $.sibling(div_1, 2);
				var node_1 = $.sibling($.child(div_3), 2);

				$.each(node_1, 17, () => $.get(page).stops, $.index, ($$anchor, stop) => {
					var div_4 = root_2();
					var div_5 = $.child(div_4);
					var span_3 = $.child(div_5);
					var span_4 = $.child(span_3);
					var text_3 = $.only_child(span_4, true);
					var span_5 = $.sibling(span_4, 2);
					var text_4 = $.only_child(span_5, true);

					$.reset(span_3);
					$.reset(div_5);
					$.reset(div_4);

					$.template_effect(
						($0) => {
							$.set_text(text_3, $.get(stop).name);
							$.set_text(text_4, $0);
						},
						[() => stopSummary($.get(stop))]
					);

					$.append($$anchor, div_4);
				});

				var div_6 = $.sibling(node_1, 2);
				var button = $.only_child(div_6);

				$.reset(div_3);

				$.template_effect(
					($0) => {
						$.set_text(text_1, $.get(page).title);
						$.set_text(text_2, `${$0 ?? ''} · server format`);
					},
					[() => pageSummary($.get(page))]
				);

				$.delegated('click', button, function (...$$args) {
					$$props.onConvert?.apply(this, $$args);
				});

				$.append($$anchor, fragment);
			};

			var alternate_5 = ($$anchor) => {
				var fragment_1 = root_27();
				var div_7 = $.first_child(fragment_1);
				let classes_1;
				var span_6 = $.child(div_7);
				var button_1 = $.sibling(span_6, 2);

				$.set_attribute(button_1, 'data-index', pageIndex);

				var span_7 = $.child(button_1);
				var span_8 = $.child(span_7);
				var text_5 = $.only_child(span_8, true);
				var span_9 = $.sibling(span_8, 2);
				var text_6 = $.only_child(span_9, true);

				$.reset(span_7);

				var node_2 = $.sibling(span_7, 2);

				chevron(node_2, () => $.get(openPage) === pageIndex);
				$.reset(button_1);
				$.reset(div_7);

				var node_3 = $.sibling(div_7, 2);

				{
					var consequent_16 = ($$anchor) => {
						var div_8 = root_26();
						var node_4 = $.child(div_8);

						{
							var consequent_2 = ($$anchor) => {
								var div_9 = root_5();
								var label = $.child(div_9);
								var input_1 = $.sibling($.child(label), 2);

								$.remove_input_defaults(input_1);
								$.reset(label);

								var label_1 = $.sibling(label, 2);
								var input_2 = $.sibling($.child(label_1), 2);

								$.remove_input_defaults(input_2);
								$.reset(label_1);

								var node_5 = $.sibling(label_1, 2);

								{
									var consequent_1 = ($$anchor) => {
										var p = root_4();
										var text_7 = $.only_child(p, true);

										$.template_effect(() => $.set_text(text_7, $.get(pathProblem)));
										$.append($$anchor, p);
									};

									$.if(node_5, ($$render) => {
										if ($.get(pathProblem)) $$render(consequent_1);
									});
								}

								var node_6 = $.sibling(node_5, 2);

								DisplayFields(node_6, {
									get draft() {
										return $.get(pageDraft).settings;
									}
								});

								var div_10 = $.sibling(node_6, 2);
								var button_2 = $.child(div_10);
								var button_3 = $.sibling(button_2, 2);

								$.reset(div_10);
								$.reset(div_9);

								$.template_effect(() => {
									$.set_attribute(input_1, 'placeholder', $.get(page).path);
									$.set_attribute(input_2, 'aria-invalid', $.get(pathProblem) !== "");
									button_3.disabled = $.get(pathProblem) !== "";
								});

								$.bind_value(input_1, () => $.get(pageDraft).title, ($$value) => $.get(pageDraft).title = $$value);
								$.bind_value(input_2, () => $.get(pageDraft).path, ($$value) => $.get(pageDraft).path = $$value);
								$.delegated('click', button_2, () => toggleForm("page"));
								$.delegated('click', button_3, () => applyPageDraft(pageIndex));
								$.append($$anchor, div_9);
							};

							$.if(node_4, ($$render) => {
								if ($.get(openForm) === "page" && $.get(pageDraft)) $$render(consequent_2);
							});
						}

						var node_7 = $.sibling(node_4, 2);

						$.each(node_7, 17, () => $.get(page).stops, $.index, ($$anchor, stop, stopIndex) => {
							var fragment_2 = root_20();
							var div_11 = $.first_child(fragment_2);
							var button_4 = $.child(div_11);
							var span_10 = $.child(button_4);
							var span_11 = $.child(span_10);
							var text_8 = $.only_child(span_11, true);
							var span_12 = $.sibling(span_11, 2);
							var text_9 = $.only_child(span_12, true);

							$.reset(span_10);

							var node_8 = $.sibling(span_10, 2);

							chevron(node_8, () => $.get(openStop) === stopIndex);
							$.reset(button_4);
							$.reset(div_11);

							var node_9 = $.sibling(div_11, 2);

							{
								var consequent_12 = ($$anchor) => {
									var div_12 = root_19();
									var label_2 = $.child(div_12);
									var input_3 = $.sibling($.child(label_2), 2);

									$.remove_input_defaults(input_3);
									$.reset(label_2);

									var label_3 = $.sibling(label_2, 2);
									var input_4 = $.sibling($.child(label_3), 2);

									$.remove_input_defaults(input_4);
									$.reset(label_3);

									var label_4 = $.sibling(label_3, 2);
									var input_5 = $.child(label_4);

									$.remove_input_defaults(input_5);
									$.next(2);
									$.reset(label_4);

									var div_13 = $.sibling(label_4, 2);
									var label_5 = $.child(div_13);
									var input_6 = $.sibling($.child(label_5), 2);

									$.remove_input_defaults(input_6);
									$.reset(label_5);

									var label_6 = $.sibling(label_5, 2);
									var input_7 = $.sibling($.child(label_6), 2);

									$.remove_input_defaults(input_7);
									$.reset(label_6);

									var label_7 = $.sibling(label_6, 2);
									var input_8 = $.sibling($.child(label_7), 2);

									$.remove_input_defaults(input_8);
									$.reset(label_7);
									$.reset(div_13);

									var node_10 = $.sibling(div_13, 2);

									$.each(node_10, 17, () => $.get(stop).directions, $.index, ($$anchor, heading, headingIndex) => {
										var fragment_3 = root_16();
										var div_14 = $.first_child(fragment_3);
										var button_5 = $.child(div_14);
										var span_13 = $.child(button_5);
										var span_14 = $.child(span_13);
										var text_10 = $.only_child(span_14, true);
										var span_15 = $.sibling(span_14, 2);
										var text_11 = $.only_child(span_15, true);

										$.reset(span_13);

										var node_11 = $.sibling(span_13, 2);

										chevron(node_11, () => $.get(openHeading) === headingIndex);
										$.reset(button_5);
										$.reset(div_14);

										var node_12 = $.sibling(div_14, 2);

										{
											var consequent_10 = ($$anchor) => {
												var div_15 = root_15();
												var label_8 = $.child(div_15);
												var input_9 = $.sibling($.child(label_8), 2);

												$.remove_input_defaults(input_9);
												$.reset(label_8);

												var div_16 = $.sibling(label_8, 2);
												var node_13 = $.child(div_16);

												{
													var consequent_3 = ($$anchor) => {
														var p_1 = root_6();

														$.append($$anchor, p_1);
													};

													$.if(node_13, ($$render) => {
														if ($.get(heading).patterns.length === 0) $$render(consequent_3);
													});
												}

												var node_14 = $.sibling(node_13, 2);

												$.each(node_14, 17, () => $.get(heading).patterns, $.index, ($$anchor, pattern, patternIndex) => {
													var div_17 = root_7();
													var input_10 = $.child(div_17);

													$.remove_input_defaults(input_10);

													var button_6 = $.sibling(input_10, 2);

													$.reset(div_17);

													$.template_effect(
														($0, $1) => {
															$.set_value(input_10, $.get(pattern));
															$.set_attribute(input_10, 'aria-label', $0);
															$.set_attribute(button_6, 'aria-label', $1);
														},
														[
															() => `Match ${patternIndex + 1} of ${headingTitle($.get(heading))}`,
															() => `Remove the match ${$.get(pattern) || patternIndex + 1} from ${headingTitle($.get(heading))}`
														]
													);

													$.delegated('change', input_10, (event) => setMatch(pageIndex, stopIndex, $.get(stop), headingIndex, patternIndex, event.currentTarget.value));
													$.delegated('click', button_6, () => removeMatch(pageIndex, stopIndex, $.get(stop), headingIndex, patternIndex));
													$.append($$anchor, div_17);
												});

												$.reset(div_16);

												var label_9 = $.sibling(div_16, 2);
												var input_11 = $.sibling($.child(label_9), 2);

												$.reset(label_9);

												var node_15 = $.sibling(label_9, 2);

												{
													var consequent_4 = ($$anchor) => {
														var p_2 = root_8();

														$.append($$anchor, p_2);
													};

													var d = $.derived(() => linesLoading.get($.get(stop).stationId));

													var consequent_5 = ($$anchor) => {
														var p_3 = root_4();
														var text_12 = $.only_child(p_3);

														$.template_effect(($0) => $.set_text(text_12, `The lines could not be loaded: ${$0 ?? ''}`), [() => linesProblem.get($.get(stop).stationId)]);
														$.append($$anchor, p_3);
													};

													var d_1 = $.derived(() => linesProblem.get($.get(stop).stationId));

													var consequent_9 = ($$anchor) => {
														var fragment_4 = $.comment();
														var node_16 = $.first_child(fragment_4);

														{
															var consequent_6 = ($$anchor) => {
																var p_4 = root_9();

																$.append($$anchor, p_4);
															};

															var d_2 = $.derived(() => linesShownFor($.get(stop)).length === 0);

															var alternate = ($$anchor) => {
																var fragment_5 = root_13();
																var node_17 = $.first_child(fragment_5);

																{
																	var consequent_7 = ($$anchor) => {
																		var label_10 = root_10();
																		var input_12 = $.sibling($.child(label_10), 2);

																		$.remove_input_defaults(input_12);
																		$.reset(label_10);

																		$.template_effect(() => {
																			$.set_value(input_12, $.get(lineFilter));
																			$.set_attribute(input_12, 'aria-label', `Filter the lines of ${$.get(stop).name}`);
																		});

																		$.delegated('input', input_12, (event) => $.set(lineFilter, event.currentTarget.value, true));
																		$.append($$anchor, label_10);
																	};

																	var d_3 = $.derived(() => linesShownFor($.get(stop)).length > 6);

																	$.if(node_17, ($$render) => {
																		if ($.get(d_3)) $$render(consequent_7);
																	});
																}

																var node_18 = $.sibling(node_17, 2);

																$.each(node_18, 17, () => shownLines($.get(stop)), (line) => line.line, ($$anchor, line) => {
																	var div_18 = root_12();
																	var button_7 = $.child(div_18);
																	let classes_2;
																	var text_13 = $.only_child(button_7, true);
																	var button_8 = $.sibling(button_7, 2);
																	var text_14 = $.only_child(button_8);
																	var node_19 = $.sibling(button_8, 2);

																	{
																		var consequent_8 = ($$anchor) => {
																			var fragment_6 = $.comment();
																			var node_20 = $.first_child(fragment_6);

																			$.each(node_20, 16, () => $.get(line).destinations, (destination) => destination, ($$anchor, destination) => {
																				var button_9 = root_11();
																				let classes_3;
																				var text_15 = $.only_child(button_9, true);

																				$.template_effect(
																					($0, $1) => {
																						classes_3 = $.set_class(button_9, 1, 'chip svelte-1gvvmj6', null, classes_3, { 'is-on': $0 });
																						$.set_attribute(button_9, 'aria-pressed', $1);
																						$.set_attribute(button_9, 'aria-label', `Add ${$.get(line).line} ${destination}`);
																						$.set_text(text_15, destination);
																					},
																					[
																						() => $.get(heading).patterns.includes(destinationPattern($.get(line).line, destination)),
																						() => $.get(heading).patterns.includes(destinationPattern($.get(line).line, destination))
																					]
																				);

																				$.delegated('click', button_9, () => addMatch(pageIndex, stopIndex, $.get(stop), headingIndex, destinationPattern($.get(line).line, destination)));
																				$.append($$anchor, button_9);
																			});

																			$.append($$anchor, fragment_6);
																		};

																		$.if(node_19, ($$render) => {
																			if ($.get(openLine) === $.get(line).line) $$render(consequent_8);
																		});
																	}

																	$.reset(div_18);

																	$.template_effect(
																		($0, $1) => {
																			classes_2 = $.set_class(button_7, 1, 'chip line svelte-1gvvmj6', null, classes_2, { 'is-on': $0 });
																			$.set_attribute(button_7, 'aria-pressed', $1);
																			$.set_attribute(button_7, 'aria-label', `Add every ${$.get(line).line} of ${$.get(stop).name}`);
																			$.set_text(text_13, $.get(line).line);
																			$.set_attribute(button_8, 'aria-expanded', $.get(openLine) === $.get(line).line);
																			$.set_attribute(button_8, 'aria-label', `Show the destinations of ${$.get(line).line}`);
																			$.set_text(text_14, `${$.get(line).destinations.length ?? ''} ▾`);
																		},
																		[
																			() => $.get(heading).patterns.includes($.get(line).line),
																			() => $.get(heading).patterns.includes($.get(line).line)
																		]
																	);

																	$.delegated('click', button_7, () => addMatch(pageIndex, stopIndex, $.get(stop), headingIndex, linePattern($.get(line).line)));
																	$.delegated('click', button_8, () => $.set(openLine, $.get(openLine) === $.get(line).line ? null : $.get(line).line, true));
																	$.append($$anchor, div_18);
																});

																$.append($$anchor, fragment_5);
															};

															$.if(node_16, ($$render) => {
																if ($.get(d_2)) $$render(consequent_6); else $$render(alternate, -1);
															});
														}

														$.append($$anchor, fragment_4);
													};

													var d_4 = $.derived(() => linesByStop.has($.get(stop).stationId));

													var alternate_1 = ($$anchor) => {
														var button_10 = root_14();

														$.delegated('click', button_10, () => loadLines($.get(stop)));
														$.append($$anchor, button_10);
													};

													$.if(node_15, ($$render) => {
														if ($.get(d)) $$render(consequent_4); else if ($.get(d_1)) $$render(consequent_5, 1); else if ($.get(d_4)) $$render(consequent_9, 2); else $$render(alternate_1, -1);
													});
												}

												var button_11 = $.sibling(node_15, 2);

												$.reset(div_15);

												$.template_effect(() => {
													$.set_value(input_9, $.get(heading).direction);
													$.set_attribute(input_9, 'aria-label', `Name of direction ${headingIndex + 1} of ${$.get(stop).name}`);
													$.set_attribute(input_11, 'aria-label', `Add a match to direction ${headingIndex + 1} of ${$.get(stop).name}`);
												});

												$.delegated('change', input_9, (event) => renameHeading(pageIndex, stopIndex, $.get(stop), headingIndex, event.currentTarget.value));
												$.delegated('change', input_11, (event) => addTypedMatch(pageIndex, stopIndex, $.get(stop), headingIndex, event.currentTarget));
												$.delegated('click', button_11, () => removeHeading(pageIndex, stopIndex, $.get(stop), headingIndex));
												$.append($$anchor, div_15);
											};

											$.if(node_12, ($$render) => {
												if ($.get(openHeading) === headingIndex) $$render(consequent_10);
											});
										}

										$.template_effect(
											($0, $1) => {
												$.set_attribute(button_5, 'aria-expanded', $.get(openHeading) === headingIndex);
												$.set_text(text_10, $0);
												$.set_text(text_11, $1);
											},
											[
												() => headingTitle($.get(heading)),
												() => headingSummary($.get(heading))
											]
										);

										$.delegated('click', button_5, () => toggleHeading(headingIndex));
										$.append($$anchor, fragment_3);
									});

									var button_12 = $.sibling(node_10, 2);
									var node_21 = $.child(button_12);

									plus(node_21);
									$.next(2);
									$.reset(button_12);

									var node_22 = $.sibling(button_12, 2);

									{
										var consequent_11 = ($$anchor) => {
											var div_19 = root_17();
											var button_13 = $.child(div_19);
											var button_14 = $.sibling(button_13, 2);
											var text_16 = $.only_child(button_14);

											$.reset(div_19);
											$.template_effect(() => $.set_text(text_16, `⨯ ${$.get(stop).name ?? ''}`));
											$.delegated('click', button_13, () => $.set(confirming, null));

											$.delegated('click', button_14, () => {
												$.set(confirming, null);
												$.set(openStop, null);
												$.set(openHeading, null);
												$$props.onRemoveStop(pageIndex, stopIndex);
											});

											$.append($$anchor, div_19);
										};

										var alternate_2 = ($$anchor) => {
											var div_20 = root_18();
											var button_15 = $.only_child(div_20);

											$.template_effect(() => $.set_attribute(button_15, 'aria-label', `Delete ${$.get(stop).name}`));
											$.delegated('click', button_15, () => $.set(confirming, `stop:${pageIndex}:${stopIndex}`));
											$.append($$anchor, div_20);
										};

										$.if(node_22, ($$render) => {
											if ($.get(confirming) === `stop:${pageIndex}:${stopIndex}`) $$render(consequent_11); else $$render(alternate_2, -1);
										});
									}

									$.reset(div_12);

									$.template_effect(
										($0, $1) => {
											$.set_value(input_3, $.get(stop).name);
											$.set_attribute(input_3, 'aria-label', `Name of ${$.get(stop).name}`);
											$.set_value(input_4, $.get(stop).label);
											$.set_attribute(input_4, 'aria-label', `Heading for ${$.get(stop).name}`);
											$.set_checked(input_5, $.get(stop).showUngrouped);
											$.set_attribute(input_5, 'aria-label', `Show unmatched departures of ${$.get(stop).name}`);
											$.set_value(input_6, $.get(stop).maxDepartures ?? "");
											$.set_attribute(input_6, 'placeholder', $0);
											$.set_attribute(input_6, 'aria-label', `Rows per stop at ${$.get(stop).name}`);
											$.set_value(input_7, $.get(stop).perLineDepartures ?? "");
											$.set_attribute(input_7, 'placeholder', $1);
											$.set_attribute(input_7, 'aria-label', `Rows per line at ${$.get(stop).name}`);
											$.set_value(input_8, $.get(stop).hoursInAdvance ?? "");
											$.set_attribute(input_8, 'aria-label', `Hours ahead at ${$.get(stop).name}`);
										},
										[
											() => String(stopDefaults.maxDeparturesPerStop),
											() => String(stopDefaults.maxDeparturesPerRoute)
										]
									);

									$.delegated('change', input_3, (event) => applyStop(pageIndex, stopIndex, $.get(stop), { name: event.currentTarget.value }));
									$.delegated('change', input_4, (event) => applyStop(pageIndex, stopIndex, $.get(stop), { label: event.currentTarget.value }));
									$.delegated('change', input_5, (event) => applyStop(pageIndex, stopIndex, $.get(stop), { showUngrouped: event.currentTarget.checked }));
									$.delegated('change', input_6, (event) => applyCount(pageIndex, stopIndex, $.get(stop), "maxDepartures", event.currentTarget));
									$.delegated('change', input_7, (event) => applyCount(pageIndex, stopIndex, $.get(stop), "perLineDepartures", event.currentTarget));
									$.delegated('change', input_8, (event) => applyCount(pageIndex, stopIndex, $.get(stop), "hoursInAdvance", event.currentTarget));
									$.delegated('click', button_12, () => addHeading(pageIndex, stopIndex, $.get(stop)));
									$.append($$anchor, div_12);
								};

								$.if(node_9, ($$render) => {
									if ($.get(openStop) === stopIndex) $$render(consequent_12);
								});
							}

							$.template_effect(
								($0) => {
									$.set_attribute(button_4, 'aria-expanded', $.get(openStop) === stopIndex);
									$.set_text(text_8, $.get(stop).name);
									$.set_text(text_9, $0);
								},
								[() => stopSummary($.get(stop))]
							);

							$.delegated('click', button_4, () => toggleStop(stopIndex, $.get(stop)));
							$.append($$anchor, fragment_2);
						});

						var node_23 = $.sibling(node_7, 2);

						{
							var consequent_14 = ($$anchor) => {
								var div_21 = root_22();
								var label_11 = $.child(div_21);
								var input_13 = $.sibling($.child(label_11), 2);

								$.remove_input_defaults(input_13);
								$.reset(label_11);

								var div_22 = $.sibling(label_11, 2);
								var button_16 = $.child(div_22);
								var button_17 = $.sibling(button_16, 2);
								var text_17 = $.only_child(button_17, true);

								$.reset(div_22);

								var node_24 = $.sibling(div_22, 2);

								{
									var consequent_13 = ($$anchor) => {
										var p_5 = root_4();
										var text_18 = $.only_child(p_5, true);

										$.template_effect(() => $.set_text(text_18, $.get(stopSearchProblem)));
										$.append($$anchor, p_5);
									};

									$.if(node_24, ($$render) => {
										if ($.get(stopSearchProblem)) $$render(consequent_13);
									});
								}

								var node_25 = $.sibling(node_24, 2);

								$.each(node_25, 17, () => $.get(stopMatches), (match) => match.stationId, ($$anchor, match) => {
									var button_18 = root_21();
									var span_16 = $.child(button_18);
									var text_19 = $.only_child(span_16, true);
									var span_17 = $.sibling(span_16, 2);
									var text_20 = $.only_child(span_17, true);
									var node_26 = $.sibling(span_17, 2);

									plus(node_26);
									$.reset(button_18);

									$.template_effect(() => {
										$.set_text(text_19, $.get(match).stationName);
										$.set_text(text_20, $.get(match).stationId);
									});

									$.delegated('click', button_18, () => addStop(pageIndex, $.get(match)));
									$.append($$anchor, button_18);
								});

								$.reset(div_21);

								$.template_effect(
									($0) => {
										button_17.disabled = $0;
										$.set_text(text_17, $.get(isSearchingStops) ? "Searching…" : "Search");
									},
									[
										() => $.get(isSearchingStops) || $.get(stopQuery).trim() === ""
									]
								);

								$.delegated('keydown', input_13, (event) => {
									if (event.key === "Enter") {
										void searchStops();
									}
								});

								$.bind_value(input_13, () => $.get(stopQuery), ($$value) => $.set(stopQuery, $$value));
								$.delegated('click', button_16, () => toggleForm("add-stop"));
								$.delegated('click', button_17, searchStops);
								$.append($$anchor, div_21);
							};

							var alternate_3 = ($$anchor) => {
								var button_19 = root_23();
								var node_27 = $.child(button_19);

								plus(node_27);
								$.next(2);
								$.reset(button_19);
								$.delegated('click', button_19, openStopSearch);
								$.append($$anchor, button_19);
							};

							$.if(node_23, ($$render) => {
								if ($.get(openForm) === "add-stop") $$render(consequent_14); else $$render(alternate_3, -1);
							});
						}

						var div_23 = $.sibling(node_23, 2);
						var button_20 = $.child(div_23);
						var node_28 = $.sibling(button_20, 2);

						{
							var consequent_15 = ($$anchor) => {
								var fragment_7 = root_24();
								var button_21 = $.first_child(fragment_7);
								var button_22 = $.sibling(button_21, 2);
								var text_21 = $.only_child(button_22);

								$.template_effect(() => $.set_text(text_21, `⨯ “${$.get(page).title ?? ''}”`));
								$.delegated('click', button_21, () => $.set(confirming, null));

								$.delegated('click', button_22, () => {
									$.set(confirming, null);
									$.set(openPage, null);
									$$props.onRemovePage(pageIndex);
								});

								$.append($$anchor, fragment_7);
							};

							var alternate_4 = ($$anchor) => {
								var button_23 = root_25();

								$.template_effect(() => $.set_attribute(button_23, 'aria-label', `Delete the route ${$.get(page).title}`));
								$.delegated('click', button_23, () => $.set(confirming, `page:${pageIndex}`));
								$.append($$anchor, button_23);
							};

							$.if(node_28, ($$render) => {
								if ($.get(confirming) === `page:${pageIndex}`) $$render(consequent_15); else $$render(alternate_4, -1);
							});
						}

						$.reset(div_23);
						$.reset(div_8);
						$.template_effect(() => $.set_attribute(button_20, 'aria-expanded', $.get(openForm) === "page"));
						$.delegated('click', button_20, () => openPageForm($.get(page)));
						$.append($$anchor, div_8);
					};

					$.if(node_3, ($$render) => {
						if ($.get(openPage) === pageIndex) $$render(consequent_16);
					});
				}

				$.template_effect(
					($0) => {
						classes_1 = $.set_class(div_7, 1, 'page-row svelte-1gvvmj6', null, classes_1, {
							dragging: $.get(dragFrom) === pageIndex,
							'drop-target': $.get(dragOver) === pageIndex && $.get(dragFrom) !== null && $.get(dragFrom) !== pageIndex
						});

						$.set_attribute(span_6, 'aria-label', `Reorder ${$.get(page).title}`);
						$.set_attribute(button_1, 'aria-expanded', $.get(openPage) === pageIndex);
						$.set_text(text_5, $.get(page).title);
						$.set_text(text_6, $0);
					},
					[() => pageSummary($.get(page))]
				);

				$.delegated('pointerdown', span_6, (event) => startDrag(event, pageIndex));

				$.delegated('keydown', span_6, (event) => {
					if (!event.altKey) {
						return;
					}

					const to = event.key === "ArrowUp" ? pageIndex - 1 : pageIndex + 1;

					if ((event.key === "ArrowUp" || event.key === "ArrowDown") && to >= 0 && to < $$props.pages.length) {
						event.preventDefault();
						$$props.onReorder(pageIndex, to);
					}
				});

				$.delegated('click', button_1, () => togglePage(pageIndex));
				$.append($$anchor, fragment_1);
			};

			$.if(node, ($$render) => {
				if ($.get(page).legacy) $$render(consequent); else $$render(alternate_5, -1);
			});
		}

		$.reset(li);
		$.append($$anchor, li);
	});

	$.reset(ul);

	var node_29 = $.sibling(ul, 2);

	{
		var consequent_17 = ($$anchor) => {
			var p_6 = root_29();

			$.append($$anchor, p_6);
		};

		$.if(node_29, ($$render) => {
			if ($$props.pages.length === 0) $$render(consequent_17);
		});
	}

	var node_30 = $.sibling(node_29, 2);

	{
		var consequent_19 = ($$anchor) => {
			var div_24 = root_30();
			var label_12 = $.child(div_24);
			var input_14 = $.sibling($.child(label_12), 2);

			$.remove_input_defaults(input_14);
			$.reset(label_12);

			var label_13 = $.sibling(label_12, 2);
			var input_15 = $.sibling($.child(label_13), 2);

			$.remove_input_defaults(input_15);
			$.reset(label_13);

			var node_31 = $.sibling(label_13, 2);

			{
				var consequent_18 = ($$anchor) => {
					var p_7 = root_4();
					var text_22 = $.only_child(p_7, true);

					$.template_effect(() => $.set_text(text_22, $.get(newPageProblem)));
					$.append($$anchor, p_7);
				};

				$.if(node_31, ($$render) => {
					if ($.get(newPageProblem)) $$render(consequent_18);
				});
			}

			var div_25 = $.sibling(node_31, 2);
			var button_24 = $.child(div_25);
			var button_25 = $.sibling(button_24, 2);

			$.reset(div_25);
			$.reset(div_24);
			$.template_effect(() => button_25.disabled = !$.get(canCreatePage));
			$.bind_value(input_14, () => $.get(newPageDraft).path, ($$value) => $.get(newPageDraft).path = $$value);
			$.bind_value(input_15, () => $.get(newPageDraft).title, ($$value) => $.get(newPageDraft).title = $$value);
			$.delegated('click', button_24, () => toggleForm("new-page"));
			$.delegated('click', button_25, applyNewPage);
			$.append($$anchor, div_24);
		};

		var alternate_6 = ($$anchor) => {
			var div_26 = root_31();
			var button_26 = $.child(div_26);
			var button_27 = $.sibling(button_26, 2);

			$.reset(div_26);
			$.delegated('click', button_26, openNewPage);

			$.delegated('click', button_27, function (...$$args) {
				$$props.onAddStops?.apply(this, $$args);
			});

			$.append($$anchor, div_26);
		};

		$.if(node_30, ($$render) => {
			if ($.get(openForm) === "new-page" && $.get(newPageDraft)) $$render(consequent_19); else $$render(alternate_6, -1);
		});
	}

	var node_32 = $.sibling(node_30, 2);

	{
		var consequent_20 = ($$anchor) => {
			var div_27 = root_32();
			var node_33 = $.child(div_27);

			DisplayFields(node_33, {
				get draft() {
					return $.get(defaultsDraft);
				}
			});

			var div_28 = $.sibling(node_33, 2);
			var button_28 = $.child(div_28);
			var button_29 = $.sibling(button_28, 2);

			$.reset(div_28);
			$.reset(div_27);
			$.delegated('click', button_28, () => toggleForm("defaults"));
			$.delegated('click', button_29, applyDefaults);
			$.append($$anchor, div_27);
		};

		var alternate_7 = ($$anchor) => {
			var button_30 = root_33();
			var span_18 = $.child(button_30);
			var span_19 = $.sibling($.child(span_18), 2);
			var text_23 = $.only_child(span_19, true);

			$.reset(span_18);

			var node_34 = $.sibling(span_18, 2);

			chevron(node_34, () => false);
			$.reset(button_30);
			$.template_effect(($0) => $.set_text(text_23, $0), [() => settingsSummary($$props.defaults)]);

			$.delegated('click', button_30, () => {
				$.set(defaultsDraft, draftOfSettings($$props.defaults), true);
				toggleForm("defaults");
			});

			$.append($$anchor, button_30);
		};

		$.if(node_32, ($$render) => {
			if ($.get(openForm) === "defaults" && $.get(defaultsDraft)) $$render(consequent_20); else $$render(alternate_7, -1);
		});
	}

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click', 'pointerdown', 'keydown', 'change', 'input']);